import React from 'react'

import { useField, useFormikContext } from 'formik'

import InputNumber from '../components/InputNumber'
import Label from '../components/Label'
import FieldProps from './FieldProps'
import Error from './FormItemError'

// import "./FormikStyles.less";

interface InputNumberProps extends FieldProps {
  defaultValue?: number
  autoFocus?: boolean
  disabled?: boolean
  min?: number
  max?: number
  precision?: number
  decimalSeparator?: string
  step?: number | string
  onPressEnter?: React.KeyboardEventHandler<HTMLInputElement>
  hideError?: boolean
}

const FormikInputNumberField: React.FC<InputNumberProps> = (props) => {
  const [field, meta] = useField(props)
  const { setFieldValue } = useFormikContext()
  const showError = meta.touched && meta.error
  const error = showError && !props.hideError && <Error>{meta.error}</Error>
  const id = props.id || props.name

  const onChange = (value: string | number | undefined) => {
    setFieldValue(props.name, value)
  }

  return (
    <>
      <div className="mb-8">
        <Label htmlFor={id}>{props.label}</Label>
        <InputNumber {...field} {...props} onChange={onChange} id={id} />
        {error}
      </div>
    </>
  )
}
export { FormikInputNumberField as InputNumber }
export default FormikInputNumberField
